import * as ADMIN_CONSTANT from 'app/shared/constants/admin-constants';
import * as locales from 'ngx-bootstrap/locale';

import { BehaviorSubject, interval } from 'rxjs';

import { CommonDataService } from '../../../group/shared/commonData.service';
import { GetTokenResponse } from 'app/model/shared/backend-api-response/get-token-response';
import { GoogleAnalyticsScriptService } from '../../../../shared/services/google-analytics-script.service';
import { GuestTypeLimit } from 'app/model/shared/backend-api-response/guest-type-limit';
import { Guid } from 'guid-typescript';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { KioskPermissions } from 'app/model/cico/backend-api-response/kiosk-permissions';
import { LANGUAGES } from 'app/shared/constants/languages-constants';
import { LanguageService } from 'modules/cico/services/language.service';
import { ProductConfigResponse } from 'model/shared/backend-api-response/product-config-response';
import { PropertySettings } from 'model/shared/backend-api-response/property-settings';
import { Wbe } from 'app/model/shared/backend-api-response/wbe';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { environment } from 'environments/environment';
import { flatMap } from 'rxjs/operators';

declare var $: any;
declare let ga: Function;
export class IDGenerator {
  length = 8;
  timestamp = +new Date();
  value: any;
  constructor() {
    this.value = this.generate();
  }
  _getRandomInt(min, max) {
    const crypto = window.crypto || window['msCrypto'];
    var array = new Uint32Array(1);
    var random = crypto.getRandomValues(array);
    console.log(random);
    return Math.floor(random[0] * (max - min + 1)) + min;
  }

  generate() {
    var ts = this.timestamp.toString();
    var parts = ts.split('').reverse();
    var id = '';

    for (var i = 0; i < this.length; ++i) {
      var index = this._getRandomInt(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }
}

@Injectable({
  providedIn: 'root',
})
export class LegacyBookInitService {
  public ssoAddToCart: boolean = true;
  public propertyTime: any;
  // public cpinStylesUrl: any;
  public casinoTokenDeleteFunction: string = 'deleteCasinoNoAndToken';
  public transactionID;
  public guestTypeLimit: any;
  public multiGuestType: boolean;
  public rGuestPayIframe: boolean = false;
  public offerConfigCloud: boolean = false;
  private _defaultOffer: string;
  public userID: any;
  public tenantId: string;
  public propertyId: string;
  private guestCount: any = 1;
  private azureUrl: string;
  private errorMessage: string;
  public PropertyData: Wbe;
  public irameTime: number = 9000;
  styleTag: any;
  public configSource = new BehaviorSubject<string>('');
  public currentMessage = this.configSource.asObservable();
  public cloudDomain: any;
  public serviceHeaders: any;
  public noEmailTrigger: boolean = false;
  public confirmationNumberLength = 50;
  public isGoogleTagManager = false;
  public tagGoogleManagerId = ''; //GTM-WW8GW8R
  public cartLimit = 100;
  public cookieRequired: boolean = false;
  public GroupLanguage: string = 'EN';
  //
  public paymentRetryInterval: any = 5000;
  public paymentRetryCounter: any = 10;
  private servername_roomCancellation: string = 'wbe-reservation-service/reservation';
  private servername_reservation: string = 'wbe-reservation-service/reservation';
  private servername_book: String = 'wbe-reservation-service/reservation';
  private servername_offer: String = 'wbe-offer-service/offer';
  private servername_restrictions: string = 'wbe-calendar-service/wbe/calendar';
  private servername_loyalty: String = 'wbe-loyalty-service/loyalty';
  private servername_room: String = 'wbe-rate-service/rate';
  private servername_yieldRates: String = 'wbe-calendar-service/wbe/calendar';
  private casinoToken_server_name: string = 'wbe-cms-service/wbe/cms';
  private iframeToken: string = 'wbe-reservation-service/reservation';
  public configData: string = 'wbe-property-service/property';
  private stayEnhance: string = 'wbe-enhancestay-service/enhancestay';
  public configUrl: string = 'wbe-property-service/property';
  public servername_admin: String = '/wbe-admin-service/generatetoken/v2/tenants/';
  public old_servername_admin: String = '/wbe-admin-service/generatetoken/tenants/';
  private servername_upsell: String = 'wbe-checkin-service/cico/checkin';
  private servername_checkin: String = 'wbe-checkin-service/cico/checkin';
  private servername_updateres: String = 'wbe-updateres-service/cico/updateres';
  private servername_inhouse: String = 'wbe-checkout-service/cico/checkout';
  private servername_checkout: String = 'wbe-checkout-service/cico/checkout';
  private servername_guestfolio: String = 'wbe-folio-service/cico/folio';
  private servername_settlefolio: String = 'wbe-folio-service/cico/folio';
  private servername_postfoliocharge: String = 'wbe-folio-service/cico/folio';
  private servername_getlatecheckout: String = 'wbe-checkout-service/cico/checkout';
  private servername_addlatecheckout: String = 'wbe-checkout-service/cico/checkout';
  private servername_redeempoints: String = 'wbe-redeempts-service/cico/redeempts';
  private servername_igcheck: String = 'wbe-igcheck-service/cico/igcheck';
  private servername_digitalKey: String = 'wbe-subscription-service';
  private servername_digitalKeyService: String = 'wbe-digitalkey-service';
  //eforms TS Changes
  private servername_eformsSign: String = 'wbe-eform-service/tenants';
  private servername_clearVerification = 'wbe-clear-service/tenants';
  //eforms TS Changes
  public guestLoginFlow: string = 'Normal';
  public tenantNotFoundData: any;
  public policyCookie: boolean;
  private cloudHeader: any;
  public configDetailsData: any;
  public tenants: any;
  // public APIContext: any;
  tenantFound: boolean = true;
  public cloudBackendDomain: string = environment.backendApiUrl;
  public expressBackendDomain: string = environment.expressBackendApiUrl;
  private cloudContextTenants: any;
  cloudContextTenents: any;
  appName: string;
  cicoClasses1: any;
  cicoClasses2: any;
  configURL: string;
  isKioskMode: boolean = window.self !== window.top;
  kioskWarningTime: number = 30;
  kioskIdleTime: number = 30000;
  defaultImageLists: any = [];
  // bookHomePageRedirectionUrl: any;
  public localeData: any;
  kioskPermissions: KioskPermissions;
  defaultRoomImageLists: any = [];
  enhancementImageLists: any = [];
  public defaultGuestCount: number = 1;
  public isCookiePolicyAcceptanceRequired: boolean = false;
  public adultsValue: any;
  public childValue: any;
  public infantsValue: any;
  public juniorValue: any;
  public disablePeopleValue: any;
  public fontsURL: any;
  public resID: any;
  public kioskVerification: any;
  public langCode: string;
  public expressConfigCloud: any = false;
  public disableBackBtn: boolean;
  private crossDomainEnabled: boolean; // TS Changes Cross Domain Tracking
  public isGroup: any = false;
  public confNoRegExp = /^[a-zA-Z 0-9.!“"”‘'’#$%&()*+,\-\/:;<=>?@\[\\\]^_`{|}~¥¢€£]{1,}$/;
  public azureBlobTokenKey: any = '';
  public admin_service = 'wbe-admin-service/';
  public isCasinoLoggedWithGuid: boolean = false;
  public hasLangCodeQueryParamGroups: boolean = false;
  public ga4Data!: {
    gaAgilysysId: string;
    gaCustomerId: string;
    isCustGaId: boolean;
  };
  private propertySettings: any;
  langConstants: any;
  public Titles = ['Mr.', 'Mrs.', 'Ms.', 'Miss.', 'Dr.', 'Rev.', 'Prof.', 'Fr.'];
  public casinoSystemType = new BehaviorSubject<boolean>(false);
  public hideDecimalPointsFromRates = false;
  public isAzureB2CAuthenticationEnabled: boolean = false;

  constructor(
    private http: HttpClient,
    public httpService: HttpService,
    private googleScript: GoogleAnalyticsScriptService,
    public commonDataService: CommonDataService,
    public _commonService: LanguageService
  ) {
    if (environment.isAzureB2CAuthenticationEnabled === 'true') {
      this.isAzureB2CAuthenticationEnabled = true;
    }
    this.localeData = locales;
    this.guestTypeLimit = [
      {
        key: 'adults',
        maxCount: 4,
      },
    ];
    this.langConstants = LANGUAGES;
  }

  public setDisableBackBtn(bool) {
    this.disableBackBtn = bool;
  }

  public getCloudHeader() {
    return this.cloudHeader;
  }
  public getContextTenents() {
    return this.cloudContextTenants;
  }

  getExpressBackendDomain() {
    const expressBackendApiUrls = this.expressBackendDomain.split(',');
    return expressBackendApiUrls[0];
  }

  checkDomain() {
    let hostName = document.location.hostname;
    console.log(hostName);
    this.cloudBackendDomain = window.location.protocol + '//' + hostName;
  }
  defineLocales() {
    for (const locale in locales) {
      if (this.PropertyData.dateFunctionConfig.dateRangePickerFormat === locales[locale].abbr) {
        defineLocale(locales[locale].abbr, locales[locale]);
      }
    }
  }

  getAnalyticsData(a, b) {
    let gaData = localStorage.getItem(a + '-' + b + '-' + 'AnalyticsId');
    console.log(gaData);
    if (!gaData) {
      this.userID = new IDGenerator().value;
      console.log(this.userID);
    } else {
      this.userID = gaData;
    }
  }
  private loadGoogleScript(propertySettings?: PropertySettings): void {
    this.ga4Data = {
      gaAgilysysId: environment?.GaAgilysysId || '',
      gaCustomerId: propertySettings?.gaCustomerId || '',
      isCustGaId: propertySettings?.isCustGaId || false,
    };

    sessionStorage.setItem('GA4Data', JSON.stringify(this.ga4Data));

    this.ga4Data && this.googleScript.loadGoogleScript();
  }

  processConfig(adminData, data) {
    let tenantId;
    let propertyId;
    let url;

    if (location.pathname != '/') {
      let pathData = location.pathname.split('/');
      console.log(pathData);
      tenantId = pathData[3];
      propertyId = pathData[4];
      this.appName = pathData[1];

      if (pathData[1] == 'cico') {
        $('body').css('overflow', 'unset');
        this.appName = pathData[1];
      } else if (pathData[2] == 'cico' || pathData[2] == 'wbe') {
        this.appName = pathData[2];
        tenantId = pathData[4];
        propertyId = pathData[5];
      } else if (pathData[1] == 'accessRestricted' || pathData[2] == 'accessRestricted') {
        this.appName = 'wbe';
        tenantId = pathData[1] == 'accessRestricted' ? pathData[2] : pathData[3];
        propertyId = pathData[1] == 'accessRestricted' ? pathData[3] : pathData[4];
      } else {
        this.appName = pathData[1];
        $('body').css('overflow', 'hidden !important');
      }
      url =
        this.cloudBackendDomain +
        '/' +
        this.configUrl +
        '/tenants/' +
        tenantId +
        '/propertyId/' +
        propertyId +
        '/appName/' +
        this.appName +
        '?' +
        new Date().getTime();
      if (pathData[2] == 'maintainance') {
        this.noEmailTrigger = true;
      }

      this.guestCount = 1;
      if (this.appName == 'wbe') {
        let transID = localStorage.getItem(tenantId + '-' + propertyId + '-' + 'transactionID');
        if (transID == 'undefined' || transID === null) {
          this.generateUniqueID(tenantId, propertyId);
        } else {
          this.transactionID = JSON.parse(localStorage.getItem(tenantId + '-' + propertyId + '-' + 'transactionID')).value;
        }
      }

      if (tenantId && propertyId) {
        this.httpService.get(url).subscribe((response: Wbe) => {
          let datares;
          datares = response;
          if (datares.Success) {
            this.propertySettings = datares?.propertySettings;
            this.commonDataService.tenantId = tenantId;
            this.commonDataService.propertyId = propertyId;
            this.commonDataService.appName = this.appName;
            this.tenantFound = true;
            this.PropertyData = response;
            this._commonService.languages.subscribe((verbiages: ProductConfigResponse) => {
              if (Object.keys(verbiages).length && verbiages.Success) {
                if (verbiages.Success) {
                  this.PropertyData['rGuestMessages'] = verbiages.propertyInitInfoMap.cico.rGuestMessages;
                }
              }
            });
            console.log(this.PropertyData);
            this.offerConfigCloud = this.PropertyData.offerConfigCloud ? this.PropertyData.offerConfigCloud : false;
            console.log(this.PropertyData.dateFunctionConfig);
            this.defaultGuestCount = this.PropertyData.defaultGuestCount ? this.PropertyData.defaultGuestCount : this.guestCount;
            this.expressConfigCloud = this.PropertyData.expressConfigCloud ? this.PropertyData.expressConfigCloud : false;
            this.kioskIdleTime = this.PropertyData.kioskIdleTime ? this.PropertyData.kioskIdleTime : this.kioskIdleTime;
            this.kioskWarningTime = this.PropertyData.kioskWarningTime ? this.PropertyData.kioskWarningTime : this.kioskWarningTime;

            this.isGoogleTagManager = this.PropertyData.isGoogleTagManager ? this.PropertyData.isGoogleTagManager : this.isGoogleTagManager;
            this.tagGoogleManagerId = this.PropertyData.tagGoogleManagerId ? this.PropertyData.tagGoogleManagerId : this.tagGoogleManagerId;
            this.langCode = this.PropertyData.langCode ? this.PropertyData.langCode.toUpperCase() : 'EN';
            if (this.appName == 'cico' && this.PropertyData.permissions) {
              if (this.PropertyData.permissions.commonPermissions) {
                var userAgent = navigator.userAgent.toLowerCase();
                if (userAgent.indexOf(' electron/') > -1 && this.PropertyData.permissions.kioskPermissions.enableKiosk) {
                  this.isKioskMode = true;
                } else {
                  this.isKioskMode = false;
                }
                // this.isKioskMode = (window.self !== window.top && this.PropertyData.permissions.kioskPermissions.enableKiosk) ? true : false;
                this.isKioskMode ? $('body').addClass('kioskModeApp') : $('body').removeClass('kioskModeApp');
              }

              if (this.PropertyData.permissions.kioskPermissions) {
                this.kioskPermissions = this.PropertyData?.permissions?.kioskPermissions;
              }
              if (this.PropertyData.permissions.reservationPermissions) {
                this.cicoClasses1 = {
                  'col-lg-1': this.PropertyData.permissions.reservationPermissions.showAdBanners,
                  'col-md-1': this.PropertyData.permissions.reservationPermissions.showAdBanners,
                  'col-lg-3': !this.PropertyData.permissions.reservationPermissions.showAdBanners,
                  'col-md-3': !this.PropertyData.permissions.reservationPermissions.showAdBanners,
                };

                this.cicoClasses2 = {
                  'col-lg-5': this.PropertyData.permissions.reservationPermissions.showAdBanners,
                  'col-md-5': this.PropertyData.permissions.reservationPermissions.showAdBanners,
                  'col-lg-6': !this.PropertyData.permissions.reservationPermissions.showAdBanners,
                  'col-md-6': !this.PropertyData.permissions.reservationPermissions.showAdBanners,
                };
              }
            }

            let serviceHeaders = {
              'Cache-Control': 'no-cache',
              Pragma: 'no-cache',
              Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
            };
            // this.APIContext = this.PropertyData['ContextId'];
            this.serviceHeaders = {
              headers: serviceHeaders,
            };
            this.setProperty(tenantId, propertyId, () => {
              data();
            });
          } else {
            this.tenantId = tenantId;
            this.propertyId = propertyId;
            this.tenantFound = false;
            this.tenantNotFoundData = response;
            data();
          }
        });
      } else {
        this.tenantId = tenantId;
        this.propertyId = propertyId;
        this.tenantFound = false;
        data();
      }
    } else {
      data();
    }
  }

  setResId(resID) {
    this.resID = resID;
  }

  setKioskVerification(kvObj) {
    this.kioskVerification = kvObj;
  }

  errorRoomImageHandler(event, list) {
    if (list) {
      var image = new Image();
      image.onload = () => {
        event.target.src = image.src;
      };
      image.onerror = () => {
        if (list && list.length) {
          this.errorRoomImageHandler(event, list);
        } else {
          event.target.src = './assets/images/image_not_found.jpg';
        }
      };
      image.src = list.shift() + `?${this.azureBlobTokenKey}`;
    }
  }

  googleAnalytics() {
    this.loadGoogleScript(this.propertySettings);
    // ---- TS Changes Cross Domain Tracking ----
    if (this.crossDomainEnabled && this.PropertyData.GaAgilysysId) {
      let gtagManager = document.createElement('script');
      gtagManager.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.PropertyData.GaAgilysysId;
      gtagManager.type = 'text/javascript';
      gtagManager.async = true;
      gtagManager.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(gtagManager);
      let gtmScript = document.createElement('script');
      gtmScript.textContent = `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}gtag('js', new Date());
            gtag('config', '${this.PropertyData.GaAgilysysId}');
            gtag('config', 'GA_MEASUREMENT_ID', {'linker': {'accept_incoming': true}});`;
      document.head.appendChild(gtmScript);
    }
    if (this.crossDomainEnabled && this.PropertyData.IsCustGaId) {
      let gtagManager = document.createElement('script');
      gtagManager.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.PropertyData.GaCustomerId;
      gtagManager.type = 'text/javascript';
      gtagManager.async = true;
      gtagManager.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(gtagManager);
      let gtmScript = document.createElement('script');
      gtmScript.textContent = `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}gtag('js', new Date());
            gtag('config', '${this.PropertyData.GaCustomerId}');
            gtag('config', 'GA_MEASUREMENT_ID', {'linker': {'accept_incoming': true}});`;
      document.head.appendChild(gtmScript);
    }

    if (this.isGoogleTagManager && this.tagGoogleManagerId !== '') {
      const googleTagManagerScript = document.createElement('script');
      googleTagManagerScript.textContent = `window.dataLayer = window.dataLayer || [];
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${this.tagGoogleManagerId}');`;
      document.head.appendChild(googleTagManagerScript);
    }
  }
  checkPolicyCookie() {
    this.policyCookie = this.getPolicyCookie(`${this.tenantId}-${this.propertyId}-policyCookie`);
    if (this.policyCookie) {
      this.googleAnalytics();
    }
  }
  getPolicyCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        var newupdatedate = new Date(c.substring(cname.length, c.length));
        this.setPolicyCookie(cname, newupdatedate, this.PropertyData.cookieExpDays ? this.PropertyData.cookieExpDays : 0);
        return true;
      }
    }
    return false;
  }
  setPolicyCookie(cname, cvalue, exdays) {
    let expires;
    if (exdays != 0) {
      var d = new Date(cvalue);
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      expires = 'expires=' + d.toUTCString();
    }
    const cleanedValue = cvalue.toString().replace(/\s*\(.*?\)$/, '');
    document.cookie = `${cname}=${cleanedValue};${expires ? expires + ';' : ''}path=/`;
  }

  setProperty(tenantId, propertyId, datas) {
    console.log('propert data ', this.PropertyData);
    if (this.appName == 'wbe') {
      this.cookieRequired = this.PropertyData.permissions.functionalPermissions.isCookiePolicyRequired
        ? this.PropertyData.permissions.functionalPermissions.isCookiePolicyRequired
        : this.cookieRequired;
      this.isCookiePolicyAcceptanceRequired = this.PropertyData.permissions.functionalPermissions.isCookiePolicyAcceptanceRequired
        ? this.PropertyData.permissions.functionalPermissions.isCookiePolicyAcceptanceRequired
        : this.isCookiePolicyAcceptanceRequired;
      this.multiGuestType = this.PropertyData.permissions.functionalPermissions.multiGuestType
        ? this.PropertyData.permissions.functionalPermissions.multiGuestType
        : false;
      this.crossDomainEnabled = this.PropertyData.permissions.functionalPermissions.isCrossDomainEnabled === true; // TS Changes Cross Domain Tracking
      this.commonDataService.groupDefaultLanguage = this.PropertyData?.langCode;

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const queryParamLangCode = urlParams.get('langCode');

      //multilanguage
      const languageSessionKey = `${this.tenantId}-${this.propertyId}-selectedLanguage`;
      if (queryParamLangCode && this.langConstants?.[queryParamLangCode.toLowerCase()]) {
        this.GroupLanguage = queryParamLangCode;
        this.hasLangCodeQueryParamGroups = true;
        this.PropertyData.langCode = this.GroupLanguage;
        this.commonDataService.getLanguages(queryParamLangCode);
      } else {
        if (
          this.PropertyData.propertySettings?.functionalPermissions?.multiLanguageSupport &&
          sessionStorage.getItem(languageSessionKey) &&
          sessionStorage.getItem(languageSessionKey) !== this.langCode &&
          !queryParamLangCode
        ) {
          this.GroupLanguage = sessionStorage.getItem(languageSessionKey) || 'EN';
          this.PropertyData.langCode = this.GroupLanguage;
          this.commonDataService.getLanguages(sessionStorage.getItem(languageSessionKey));
        } else {
          sessionStorage.setItem(`${this.tenantId}-${this.propertyId}-selectedLanguage`, this.PropertyData.langCode);
          this.GroupLanguage = this.PropertyData.langCode || 'EN';
          if (queryParamLangCode) {
            this.commonDataService.checkForLangCodeQueryParam(languageSessionKey, this.GroupLanguage);
          }
        }
      }
    } else if (this.appName == 'cico') {
      this.cookieRequired = this.PropertyData.permissions.commonPermissions.isCookiePolicyRequired
        ? this.PropertyData.permissions.commonPermissions.isCookiePolicyRequired
        : this.cookieRequired;
      this.isCookiePolicyAcceptanceRequired = this.PropertyData.permissions.commonPermissions.isCookiePolicyAcceptanceRequired
        ? this.PropertyData.permissions.commonPermissions.isCookiePolicyAcceptanceRequired
        : this.isCookiePolicyAcceptanceRequired;
    }
    if (this.cookieRequired && !this.isKioskMode) {
      this.checkPolicyCookie();
    } else {
      this.googleAnalytics();
    }
    this.tenantId = tenantId;
    this.propertyId = propertyId;
    this.commonDataService.tenantId = tenantId;
    this.commonDataService.propertyId = propertyId;
    this.commonDataService.appName = this.appName;
    this._defaultOffer = this.PropertyData.defaultOffer;
    if (this.appName == 'wbe' && this.PropertyData.permissions.functionalPermissions.encryptOfferCodeinURL)
      this._defaultOffer = this.convertOfferCode(this._defaultOffer, 'encrypt');

    if (this.appName == 'wbe' && !this.PropertyData.permissions.functionalPermissions.addToCart) {
      localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-GuestLayout');
      localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-cart');
      localStorage.removeItem(this.tenantId + '-' + this.propertyId + '-validEnhancedata');
    }
    this.guestLoginFlow = this.PropertyData.guestLoginFlow ? this.PropertyData.guestLoginFlow : this.guestLoginFlow;
    if (this.PropertyData && this.PropertyData.casinoSystemType) {
      this.casinoSystemType.next(this.PropertyData?.casinoSystemType?.toLowerCase() === 'gigya');
    }
    this.hideDecimalPointsFromRates = this.propertySettings?.functionalPermissions?.hideDecimalPointsFromRates;
    this.defaultGuestCount = this.PropertyData.defaultGuestCount ? this.PropertyData.defaultGuestCount : this.guestCount;
    this.guestTypeLimit = this.PropertyData.guestTypeLimit ? this.PropertyData.guestTypeLimit : this.guestTypeLimit;
    this.fetchMessages();
    if (this.PropertyData.countryCode) this.defineLocales();
    // this.defineLocales();
    this.cartLimit = this.PropertyData.cartLimit;
    this.confirmationNumberLength = this.PropertyData.confirmationNumberLength
      ? this.PropertyData.confirmationNumberLength
      : this.confirmationNumberLength;
    this.paymentRetryInterval = this.PropertyData.paymentRetryInterval ? this.PropertyData.paymentRetryInterval : this.paymentRetryInterval;
    this.paymentRetryCounter = this.PropertyData.paymentRetryCounter ? this.PropertyData.paymentRetryCounter : this.paymentRetryCounter;
    this.getAnalyticsData(this.tenantId, this.propertyId);

    this.defaultImageLists = [ADMIN_CONSTANT.DEFAULT_IMAGE_PATH.defaultImgPlaceholder];
    this.defaultRoomImageLists = [
      this.PropertyData.UrlMap.ImageUrl + '/rooms/default.jpg',
      ADMIN_CONSTANT.DEFAULT_IMAGE_PATH.defaultImgPlaceholder,
    ];
    this.enhancementImageLists = [
      this.PropertyData.UrlMap.defaultEnhancementImageUrl,
      this.PropertyData.UrlMap.AssetsUrl + '/enhancements/default.jpg',
    ];
    if (this.PropertyData.UrlMap.MaintenaceStatus == 'true') {
      this.processThemeService(() => {
        this.tenantId = tenantId;
        this.propertyId = propertyId;
        this.tenantFound = true;
        datas();
      });
    }

    let url =
      this.cloudBackendDomain +
      '/' +
      this.configUrl +
      '/tenants/' +
      this.tenantId +
      '/context/' +
      this.PropertyData.ContextId +
      '/' +
      'propertyName/' +
      this.PropertyData.PropNameKeyList.config +
      '/propertyId/' +
      this.propertyId +
      `?appName=${this.appName}&ts=` +
      new Date().getTime();
    this.httpService.get(url, this.serviceHeaders).subscribe((response) => {
      this.processThemeService(() => {
        if (response['Success']) {
          this.configDetailsData = response;
          if (this.propertyId == 'venetian') {
            this.configDetailsData.propertyName = 'The Venetian Resort';
          }
          if (
            this.PropertyData.PropNameKeyList.book == undefined ||
            this.PropertyData.PropNameKeyList.book == null ||
            this.PropertyData.PropNameKeyList.book == ''
          ) {
          } else {
            this.configSource.next('success');
          }
          datas();
        } else {
          this.configDetailsData = response;
          this.tenantId = tenantId;
          this.propertyId = propertyId;
          this.PropertyData.UrlMap.MaintenaceStatus = 'true';
          datas();
        }
      });
    });
  }

  processThemeService(data2) {
    this.http
      .get(this.PropertyData.UrlMap.StylUrl + '?' + this.azureBlobTokenKey + '&t=' + new Date().getTime(), { responseType: 'text' })
      .subscribe((val: any) => {
        let style = val;
        this.injectStylesheet(style, 'app-theme-from-adminportal');
        this.http
          .get('./assets/styles_' + this.appName + '.css?' + this.azureBlobTokenKey, { responseType: 'text' })
          .subscribe((val1: any) => {
            let style1 = val1;
            this.injectStylesheet(style1, 'app-theme-from-assets');
            data2();
          });
      });
  }

  injectStylesheet(css, id) {
    $('#' + id).remove();
    const head = document.head || document.getElementsByTagName('head')[0];
    this.styleTag = document.createElement('style');
    this.styleTag.type = 'text/css';
    this.styleTag.id = id;
    this.styleTag.textContent = css;
    head.appendChild(this.styleTag);
  }
  load(azureblobtokenkey) {
    this.azureBlobTokenKey = azureblobtokenkey;
    return new Promise(async (resolve, reject) => {
      this.configURL = environment.azureAccountUrl;

      if (environment.showLogs) {
        console.log('Environent data - azureAccountUrl :  ', environment.azureAccountUrl);
        console.log('Environent data - showLogs :  ', environment.showLogs);
        console.log('Environent data - proxy :  ', environment.proxy);
        console.log('Environent data - node api url', environment.nodeApiUrl);
      } else {
        if (window) {
          window.console.log = function () {};
        }
      }
      if (environment.proxy) {
        this.httpService.proxy = environment.proxy;
        this.httpService.apiUrl = environment.nodeApiUrl;
        this.cloudBackendDomain = environment.backendApiUrl;
      } else {
        let hostName = document.location.hostname;
        this.cloudBackendDomain = window.location.protocol + '//' + hostName;
      }
      this.fontsURL = `./assets/fonts/`;
      this.checkDomain();

      if (location.pathname != '/') {
        let pathData = location.pathname.split('/');
        console.log(pathData);
        this.tenantId = pathData[3];
        this.propertyId = pathData[4];
        this.appName = pathData[1];
        if (pathData[1] == 'cico') {
          $('body').css('overflow', 'unset');
          this.appName = pathData[1];
        } else if (pathData[2] == 'cico' || pathData[2] == 'wbe') {
          this.appName = pathData[2];
          this.tenantId = pathData[4];
          this.propertyId = pathData[5];
        } else if (pathData[1] == 'accessRestricted' || pathData[2] == 'accessRestricted') {
          this.appName = 'wbe';
          this.tenantId = pathData[1] == 'accessRestricted' ? pathData[2] : pathData[3];
          this.propertyId = pathData[1] == 'accessRestricted' ? pathData[3] : pathData[4];
        } else {
          this.appName = pathData[1];
          $('body').css('overflow', 'hidden !important');
        }
        if (this.appName == 'wbe' && location.pathname.includes('wbe/group')) {
          this.isGroup = true;
        }
        if (environment.proxy && this.appName == 'cico') {
          this.cloudBackendDomain = environment.expressBackendApiUrl;
        }
        this.httpService.appname = this.appName;
      }

      let adminTokenURL;

      // let azure = await this.getAzureBlobToken();

      if (this.tenantId && this.propertyId) {
        var servicePath: String = this.isAzureB2CAuthenticationEnabled ? this.servername_admin : this.old_servername_admin;
        adminTokenURL =
          this.cloudBackendDomain +
          servicePath +
          this.tenantId +
          '/propertyId/' +
          this.propertyId +
          '/appName/' +
          this.appName +
          '?' +
          new Date().getTime();
        this.initializeDate(adminTokenURL).then((data) => {
          if (data) {
            console.log('Initial Token is ', data);
            this.processConfig(data, () => {
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });

        interval(12 * 60 * 1000)
          .pipe(flatMap(() => this.initializeDate(adminTokenURL)))
          .subscribe((adminData) => {
            console.log('New Token Generated ', adminData);
            if (adminData && adminData['success']) {
              let serviceHeaders = {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
              };
              this.serviceHeaders = {
                headers: serviceHeaders,
              };
            }
          });
        // }
      } else {
        this.tenantFound = false;
        resolve(true);
      }
    });
  }

  async initializeDate(adminTokenURL) {
    let secondaryPromise = await this.getXtoken(adminTokenURL).then(
      (data: GetTokenResponse) => {
        console.log(data);
        this.commonDataService.token = data.token;
        return data;
      },
      (error) => {
        console.log('error out man:', error.error);
        this.tenantNotFoundData = {
          Success: error.error.success,
          ErrorMessage: error.error.errorMessage,
        };
        this.tenantFound = false;
      }
    );

    return secondaryPromise;
  }

  // async getAzureBlobToken() {
  //   let url = this.cloudBackendDomain + '/' + this.admin_service + 'generateAzureBlobStorageSAS';
  //   let tokenResponse: any = await this.httpService.get(url).toPromise();
  //   if (tokenResponse.success) {
  //     if (!this.azureBlobTokenKey) {
  //       setInterval(() => {
  //         this.getAzureBlobToken();
  //       }, 3 * 60 * 1000);
  //     }
  //     this.azureBlobTokenKey = tokenResponse.token;
  //   }
  // }

  getXtoken(adminTokenURL) {
    return this.httpService.get(adminTokenURL).toPromise();
  }

  convertOfferCode(text, mode) {
    let conversionOutput;
    try {
      if (mode == 'encrypt') {
        //encrypt
        let btoa = window.btoa(text);
        conversionOutput = btoa.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
      } else {
        conversionOutput = window.atob(text);
      }
      return conversionOutput;
    } catch (error) {
      return 'INVALID_OFFER';
    }
  }
  getserverDetails_offer = function () {
    return this.servername_offer;
  };
  getserverDetails_room = function () {
    return this.servername_room;
  };
  getCardProcessing = function () {
    return this.iframeToken;
  };

  getIframeData = function () {
    let data: object = {
      payUrl: this.PropertyData.UrlMap.PaymentIframeUrl,
      cssUrl: this.PropertyData.UrlMap.PaymentStylesUrl,
    };
    return data;
  };
  getCloudDomainName = function () {
    return this.cloudBackendDomain;
  };
  getenhanceData = function () {
    return this.stayEnhance;
  };
  getConfig = function () {
    return this.configData;
  };
  getserverDetails_book = function () {
    return this.servername_book;
  };
  getserverDetails_loyalty = function () {
    return this.servername_loyalty;
  };

  gettenantId = function () {
    return this.tenantId;
  };
  getpropertyId = function () {
    return this.propertyId;
  };

  getguest_count = function () {
    return this.defaultGuestCount;
  };

  getserverReservation = function () {
    return this.servername_reservation;
  };

  getServerRoomCancellation = function () {
    return this.servername_roomCancellation;
  };

  getServerRestrictions = function () {
    return this.servername_restrictions;
  };

  getcasioToken_server_name = () => {
    return this.casinoToken_server_name;
  };

  getyieldRates_server_name = () => {
    return this.servername_yieldRates;
  };

  getServerUpsell = function () {
    return this.servername_upsell;
  };
  getServerCheckIn = function () {
    return this.servername_checkin;
  };
  getserverInHouse = function () {
    return this.servername_inhouse;
  };
  getServerUpdateRes = function () {
    return this.servername_updateres;
  };

  getServerCheckout = function () {
    return this.servername_checkout;
  };

  getServerGuestFolio = function () {
    return this.servername_guestfolio;
  };

  getServerPostFolioCharge = function () {
    return this.servername_postfoliocharge;
  };

  getServerSettleFolio = function () {
    return this.servername_settlefolio;
  };

  getServerGetLateCheckout = function () {
    return this.servername_getlatecheckout;
  };

  getServerAddLateCheckout = function () {
    return this.servername_addlatecheckout;
  };

  getServerRedeemPoints = function () {
    return this.servername_redeempoints;
  };

  getServerIgCheck = function () {
    return this.servername_igcheck;
  };

  getServerDigitalKey = function () {
    return this.servername_digitalKey;
  };

  getServerDigitalKeyService = function () {
    return this.servername_digitalKeyService;
  };
  public defaultOffer(): string {
    return this._defaultOffer;
  }
  // eforms TS Changes
  getEformsSign = function () {
    return this.servername_eformsSign;
  };

  get clearServiceName(): string {
    return this.servername_clearVerification;
  }

  // eforms TS Changes

  generateUniqueID(tenantId, propertyId) {
    this.transactionID = Guid.create();
    console.log('Transaction ID is: ' + this.transactionID);
  }
  fetchMessages() {
    if (this.multiGuestType && this.guestTypeLimit && this.PropertyData.rGuestMessages && this.PropertyData.rGuestMessages.rooms) {
      this.guestTypeLimit.forEach((element) => {
        element['label'] = `${this.PropertyData.rGuestMessages.rooms[element['key'] + 'LabelName']}`;
        element['toolTip'] = `${this.PropertyData.rGuestMessages.rooms[element['key'] + 'ToolTip']}`;
        if (element['key'] === 'adults') {
          element['selectedValue'] = element['selectedValue']
            ? element['selectedValue']
            : this.PropertyData.defaultGuestCount
            ? this.PropertyData.defaultGuestCount
            : this.guestCount;
        }
      });
      console.log(this.guestTypeLimit);
    }
  }

  getErrorMessage(statusCode) {
    let err = (this.PropertyData && this.PropertyData.rGuestMessages && this.PropertyData.rGuestMessages.errorMessages) || {};
    return err[statusCode] || '';
  }
}
